// import { ArrowDown } from '@outdoor-voices/ui';
// import { isTwoColumn } from '@outdoor-voices/ui/dist/utils/dom/isMobile';
import { useRef } from 'react';
// import { useInView } from 'react-intersection-observer';

// import { SCROLL } from '../../config/constants';
import css from './steps.module.scss';
import Image from 'next/image';
import React from 'react';
// import { SCROLL } from '../../config/constants';

// type BGProps = {
//   title: string;
// };
// const BG: React.FC<BGProps> = memo(() => {
//   // const onSkip = () => {
//   //   const campaigns = document.getElementById('ways-to-score');
//   //   campaigns.scrollIntoView({ behavior: 'smooth' });
//   // };

//   return (
//     <div className={css.bg}>
//       <div aria-hidden="true" className={css.imgWrap} role="presentation">
//         <div
//           className={css.desktop}
//           role="presentation"
//           aria-hidden="true"
//           style={{
//             background: 'url(/_next/image?url=%2Floyalty%2Fsteps.jpg&w=3840&q=75)',
//             backgroundSize: '1200px 500px',
//           }}
//         >
// <Image alt="Grid paper" src="/loyalty/steps.jpg" layout="fill" objectFit="cover" height="500" width="1200" />
//         </div>
//         <div
//           className={css.mobile}
//           role="presentation"
//           aria-hidden="true"
//           style={{
//             background: 'url(/_next/image?url=%2Floyalty%2Fsteps-mobile.jpg&w=3840&q=75)',
//             backgroundSize: '420px 675px',
//           }}
//         >
//           {/* <Image
//             alt="Grid paper"
//             src="/loyalty/steps-mobile.jpg"
//             layout="fill"
//             // height="675"
//             // width="420"
//             objectFit="cover"
//             objectPosition="center"
//           /> */}
//         </div>
//       </div>
//       {/* <button
//         aria-label={`Click to skip the section about ${title}`}
//         className={css.skip}
//         onClick={onSkip}
//         type="button"
//       >
//         <ArrowDown />
//         Skip
//       </button> */}
//     </div>
//   );
// });

type Step = {
  id: number;
  label: string;
  title: string;
  description: string;
};
type Props = {
  description: string;
  steps: Step[];
  title: string;
};
const Steps: React.FC<Props> = ({ description, steps, title }) => {
  // const bottom = useRef<HTMLDivElement>(null);
  // const top = useRef<HTMLDivElement>(null);
  const root = useRef<HTMLDivElement>(null);
  // const [sticky, setSticky] = useState(false);
  // const { ref, inView } = useInView({
  //   threshold: 0,
  //   rootMargin: '0px',
  // });

  // useEffect(() => {
  //   if (!inView) {
  //     return;
  //   }
  //   const { current } = top;
  //   const observer = new IntersectionObserver(
  //     ([record]) => {
  //       const targetInfo = record.boundingClientRect;
  //       const rootBoundsInfo = record.rootBounds;

  //       // Started sticking.
  //       if (!sticky && targetInfo.bottom < rootBoundsInfo.top) {
  //         setSticky(true);
  //       }

  //       // Stopped sticking.
  //       if (sticky && targetInfo.bottom >= rootBoundsInfo.top && targetInfo.bottom < rootBoundsInfo.bottom) {
  //         setSticky(false);
  //       }
  //     },
  //     { threshold: [0], rootMargin: '-72px 0px 0px' },
  //   );
  //   observer.observe(current);
  //   // unmount
  //   return () => {
  //     observer.unobserve(current);
  //   };
  // }, [sticky, inView, top]);

  // useEffect(() => {
  //   const { current } = bottom;
  //   // console.info('bottom', current, inView);
  //   if (!inView) {
  //     return;
  //   }

  //   const observer = new IntersectionObserver(
  //     ([record]) => {
  //       const targetInfo = record.boundingClientRect;
  //       const rootBoundsInfo = record.rootBounds;
  //       const ratio = record.intersectionRatio;

  //       // Started sticking.
  //       if (!sticky && targetInfo.bottom > rootBoundsInfo.top && ratio === 1) {
  //         console.info('bottom stick');
  //         // setSticky(true);
  //       }

  //       // Stopped sticking.
  //       if (sticky && targetInfo.top < rootBoundsInfo.top && targetInfo.bottom < rootBoundsInfo.bottom) {
  //         console.info('bottom unstick');
  //         // setSticky(false);
  //       }
  //     },
  //     { threshold: [1], rootMargin: '-72px 0px 0px' },
  //   );
  //   observer.observe(current);
  //   // unmount
  //   return () => {
  //     observer.unobserve(current);
  //   };
  // }, [sticky, inView, bottom]);

  // useEffect(() => {
  //   if (!inView || isTwoColumn()) {
  //     return;
  //   }
  //   const onScroll = () => {
  //     const tarY = -Math.round(Math.min(root.current.getBoundingClientRect().top + document.body.scrollTop - 72, 0));
  //     const newMargin = Math.min(-(root.current.offsetHeight - tarY - 500), 0);
  //     root.current.style.marginBottom = `${newMargin}px`;
  //   };
  //   window.addEventListener(SCROLL, onScroll);
  //   onScroll();

  //   return () => {
  //     window.removeEventListener(SCROLL, onScroll);
  //   };
  // }, [inView]);

  return (
    <section
      className={css.wrap}
      id="how-it-works"
      style={{
        background: 'url(/_next/image?url=%2Floyalty%2Fsteps.jpg&w=3840&q=75)',
        backgroundSize: '1200px 500px',
      }}
    >
      {/* <div className={cc([css.sentinel, css.top])} ref={top} role="presentation"></div> */}
      {/* <BG title={title} /> */}
      <div className={css.root} ref={root}>
        <div className={css.header}>
          <div aria-hidden="true" className={css.playbookO} role="presentation">
            <Image
              alt="Playbook O"
              height="117"
              layout="responsive"
              objectFit="contain"
              src="/loyalty/playbook-o.png"
              width="160"
            />
          </div>
          <h2 className={css.title}>
            <Image
              alt={title}
              height="170"
              layout="responsive"
              objectFit="contain"
              src="/loyalty/how-it-works.png"
              width="1010"
              priority
            />
          </h2>
          <p className={css.description}>{description}</p>
          <div aria-hidden="true" className={css.playbookX} role="presentation">
            <Image
              alt="Playbook X"
              height="116"
              layout="responsive"
              objectFit="contain"
              src="/loyalty/playbook-x.png"
              width="159"
            />
          </div>
        </div>
        <ul className={css.list}>
          {steps.map(({ id, title, label, description }, idx) => (
            <li className={css.item} key={id}>
              <div className={css.border}>
                <div aria-hidden="true" className={css.star} role="presentation">
                  <Image
                    alt="Star"
                    height="326"
                    layout="responsive"
                    objectFit="contain"
                    src="/loyalty/star.png"
                    width="324"
                  />
                </div>
                {idx < steps.length - 1 && (
                  <div aria-hidden="true" className={css.line} role="presentation">
                    <Image alt="Line" height="441" layout="responsive" src="/loyalty/line.png" width="21" />
                  </div>
                )}
              </div>
              <div>
                <div className={css.label}>{label}</div>
                <h3 className={css.itemTitle}>{title}</h3>
                <p className={css.itemDescription}>{description}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
      {/* {inView && <div className={cc([css.mask, { [css.stuck]: sticky }])} role="presentation"></div>} */}
      {/* <div className={cc([css.sentinel, css.bottom])} ref={bottom} role="presentation"></div> */}
    </section>
  );
};
export default Steps;
